import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border/50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/home" className="flex items-center gap-2">
          <span className="text-3xl">🐸</span>
          <span className="font-display font-bold text-xl text-foreground">HabitFrog</span>
        </Link>
        <Button variant="coral" asChild>
          <Link to="/auth">Entrar</Link>
        </Button>
      </div>
    </header>
  );
};

export default Header;
